import Select from 'react-select';

const PURPOSE_OPTIONS = [
    { value: 'mixer', label: 'Mixer' },
    { value: 'pump', label: 'Pump' },
    { value: 'dg_set', label: 'DG Set' },
    { value: 'tipper', label: 'Tipper' },
    { value: 'loader', label: 'Loader' },
    { value: 'generator', label: 'Generator' },
    { value: 'other', label: 'Other' },
];

function resolvePurposeFromEquipment(equipment) {
    if (!equipment) return '';
    const typeName = String(
        equipment.equip_type?.name || equipment.equip_grp_name || ''
    ).toUpperCase().trim();

    if (!typeName) return 'other';
    if (typeName.includes('MIXER')) return 'mixer';
    if (typeName.includes('PUMP')) return 'pump';
    if (typeName.includes('DG') || typeName.includes('D.G')) return 'dg_set';
    if (typeName.includes('TIPPER')) return 'tipper';
    if (typeName.includes('LOADER')) return 'loader';
    if (typeName.includes('GENERATOR')) return 'generator';
    return 'other';
}

function resolveOpeningMeterFromEquipment(equipment) {
    if (!equipment) return 0;
    const meterReading = Number(equipment.meter_reading);
    if (meterReading > 0) return meterReading;
    const hourMeter = Number(equipment.equip_open_hm || equipment.co_open_hm);
    if (hourMeter > 0) return hourMeter;
    return 0;
}

function TableRowsDieselConsumption({
    rowsData,
    equipments,
    dieselProducts,
    onChange,
    onRemove,
    readOnly = false,
}) {
    const equipmentOptions = (equipments || []).map((e) => ({
        value: e.id,
        label: e.equip_name || e.name,
        equipment: e,
    }));

    const productOptions = (dieselProducts || []).map((p) => ({
        value: p.id,
        label: p.name,
        unit: p.unit?.name || p.unit_name || 'Ltr',
    }));

    const handleEquipmentSelect = (index, option) => {
        const equipment = option?.equipment
            || (equipments || []).find((e) => e.id === option?.value);
        const updated = [...rowsData];
        updated[index] = {
            ...updated[index],
            equipment_id: option?.value || '',
            equipment_name: option?.label || '',
            purpose: equipment ? resolvePurposeFromEquipment(equipment) : '',
            opening_meter: equipment ? resolveOpeningMeterFromEquipment(equipment) : 0,
        };
        onChange(updated);
    };

    const handleProductSelect = (index, option) => {
        const updated = [...rowsData];
        updated[index] = {
            ...updated[index],
            product_id: option?.value || '',
            product_name: option?.label || '',
            unit: option?.unit || updated[index].unit || 'Ltr',
        };
        onChange(updated);
    };

    const handleFieldChange = (index, name, value) => {
        const updated = [...rowsData];
        updated[index] = { ...updated[index], [name]: value };

        if (name === 'opening_meter' || name === 'closing_meter') {
            const opening = parseFloat(updated[index].opening_meter) || 0;
            const closing = parseFloat(updated[index].closing_meter) || 0;
            if (closing > opening) {
                updated[index].consumed_qty = parseFloat((closing - opening).toFixed(3));
            }
        }

        onChange(updated);
    };

    return (
        <>
            {rowsData.map((row, index) => (
                <tr key={row.line_no || index} className="text-center detailclass">
                    {!readOnly && (
                        <td>
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => onRemove(index)}
                            >
                                Remove
                            </button>
                        </td>
                    )}
                    <td>{index + 1}</td>
                    <td style={{ minWidth: '180px' }}>
                        {readOnly ? (
                            row.equipment_name || '-'
                        ) : (
                            <Select
                                options={equipmentOptions}
                                value={equipmentOptions.find((o) => o.value === row.equipment_id) || null}
                                onChange={(opt) => handleEquipmentSelect(index, opt)}
                                placeholder="Select equipment"
                                isClearable
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                        )}
                    </td>
                    <td>
                        {readOnly ? row.driver_name : (
                            <input
                                className="form-control form-control-sm"
                                value={row.driver_name || ''}
                                onChange={(e) => handleFieldChange(index, 'driver_name', e.target.value)}
                            />
                        )}
                    </td>
                    <td style={{ minWidth: '140px' }}>
                        {readOnly ? (
                            PURPOSE_OPTIONS.find((o) => o.value === row.purpose)?.label || row.purpose || '-'
                        ) : (
                            <select
                                className="form-control form-control-sm"
                                value={row.purpose || ''}
                                onChange={(e) => handleFieldChange(index, 'purpose', e.target.value)}
                            >
                                <option value="">Select</option>
                                {PURPOSE_OPTIONS.map((o) => (
                                    <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                            </select>
                        )}
                    </td>
                    <td style={{ minWidth: '160px' }}>
                        {readOnly ? (
                            row.product_name
                        ) : (
                            <Select
                                options={productOptions}
                                value={productOptions.find((o) => o.value === row.product_id) || null}
                                onChange={(opt) => handleProductSelect(index, opt)}
                                placeholder="Select diesel"
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                        )}
                    </td>
                    <td>
                        {readOnly ? Number(row.opening_meter || 0).toFixed(3) : (
                            <input
                                type="number"
                                step="0.001"
                                className="form-control form-control-sm"
                                style={{ textAlign: 'right' }}
                                value={row.opening_meter || 0}
                                onChange={(e) => handleFieldChange(index, 'opening_meter', e.target.value)}
                            />
                        )}
                    </td>
                    <td>
                        {readOnly ? Number(row.closing_meter || 0).toFixed(3) : (
                            <input
                                type="number"
                                step="0.001"
                                className="form-control form-control-sm"
                                style={{ textAlign: 'right' }}
                                value={row.closing_meter || 0}
                                onChange={(e) => handleFieldChange(index, 'closing_meter', e.target.value)}
                            />
                        )}
                    </td>
                    <td>
                        {readOnly ? Number(row.consumed_qty || 0).toFixed(3) : (
                            <input
                                type="number"
                                step="0.001"
                                min="0"
                                required
                                className="form-control form-control-sm"
                                style={{ textAlign: 'right' }}
                                value={row.consumed_qty || 0}
                                onChange={(e) => handleFieldChange(index, 'consumed_qty', e.target.value)}
                            />
                        )}
                    </td>
                    <td>{row.unit || 'Ltr'}</td>
                </tr>
            ))}
        </>
    );
}

export default TableRowsDieselConsumption;
